var EHDI = EHDI || Object.create(null);

EHDI.popup = EHDI.popup || Object.create(null);

EHDI.popup.PostGamePopUp = function(stars, score) {
    EHDI.aka.Container.call(this);
    
    this.starCount = stars;
    this.score = score;
};

EHDI.popup.PostGamePopUp.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.popup.PostGamePopUp.prototype.popUpWillAppear = function () {
    this.overlay = EHDI.displays.FillRectangle(0x000000, 0, 0, EHDI.GAME.sceneManager.getStageWidth(), EHDI.GAME.sceneManager.getStageHeight(), 0);
    
    this.overlay.anchor.set(0.5, 0.5);
    
    this.addChild(this.overlay);
    
    this.position.x = EHDI.GAME.sceneManager.getStageWidth() * 0.5;
    this.bg = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_pop"]);
    this.bg.anchor.set(0.5, 0.5);
    
    this.addChild(this.bg);
    this.bg.visible=false;
};

EHDI.popup.PostGamePopUp.prototype.popUpDidAppear = function () {
    this.overlay.alpha = 0.5;
    this.overlay.interactive = true;
    
    this.gameOverText = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_GAMEOVER"));
    this.gameOverText.anchor.set(0.5,0.5);
    this.gameOverText.position.set(-this.bg.width * 0.2, -this.bg.width * 0.24);
    this.bg.addChild(this.gameOverText);
    
    this.return = new EHDI.displays.Button(EHDI.Assets.images["btn_return"], EHDI.Assets.images["btn_return2"], null, null);
    
    this.return.position.set(0, this.bg.height * 0.35);
    
    this.return.setOnClickFunction(this.goToTitleScreen.bind(this));
    
    this.bg.addChild(this.return);
    
    this.starBG = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_starbg"]);
    this.starBG.position.set(0, -this.bg.height * 0.175)
    this.starBG.anchor.set(0.5, 0.5);
    this.bg.addChild(this.starBG);
    
    this.stars = [];
    
    for(var i = 0; i < 3; i++) {
        var starback = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_star0"]);
        
        var star = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_star1"]);
        this.starBG.addChild(starback);
        this.stars.push(star);
        star.anchor.set(0.5, 0.5);
        starback.anchor.set(0.5,0.5);
        star.scale.set(1.2, 1.2);
        starback.position.set(this.starBG.width * (-0.15 + (0.15 * i)), 0);
        
        starback.addChild(star);
        star.visible = false;
    }
    
    this.scoreText = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_SCORE"));
    this.scoreText.text += this.score;
    this.scoreText.anchor.set(0.5, 0.5);
    this.scoreText.position.set(0, this.bg.height * 0.035);
    this.bg.addChild(this.scoreText);

    
    var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
    if(this.score >= cache.highScore) {
    cache.highScore = this.score;
    console.log("cache.highScore");
    console.log(cache.highScore);
    EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
    }
    
    this.highscoreText = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_BESTSCORE"));
    this.highscoreText.text += cache.highScore;
    this.highscoreText.anchor.set(0.5, 0.5);
    this.highscoreText.position.set(0, this.bg.height * 0.15);
    this.bg.addChild(this.highscoreText);
    
    this.explode = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_explode"]);
    this.explode.alpha = 0;
    this.explode.anchor.set(0.5, 0.5);
    this.explode.scale.set(0.5, 0.5);
    this.starBG.addChild(this.explode);
    this.starAnimationTL = new TimelineMax({delay: 0.25});
    for(var i = 0; i < this.starCount; i++) { 
        this.starAnimationTL.addCallback(this.showStar, "+=0", [this.stars[i]]);
        this.starAnimationTL.to(this.explode, 0, {x : this.starBG.width * (-0.15 + (0.15 * i)), alpha : 1}, "+=0.00001");
       
        this.starAnimationTL.to(this.stars[i].scale, 0.5, {x : 1, y : 1});
        this.starAnimationTL.to(this.explode.scale, 0.6, {x : 1, y : 1}, "-=0.5");
        this.starAnimationTL.to(this.explode, 0.6, {alpha : 0}, "-=0.5");
        this.starAnimationTL.to(this.explode.scale, 0, {x : 0.5, y : 0.5});
    }
   EHDI.GAME.soundManager.setMute(true);
    location.href = "?score=" + this.score;
    
      this.bg.visible=false;
    
//    this.starAnimationTL.play();
};

EHDI.popup.PostGamePopUp.prototype.showStar = function(star) {
    star.visible = true;

    EHDI.GAME.soundManager.playSFX("star_gain");
};

EHDI.popup.PostGamePopUp.prototype.goToTitleScreen = function() {
    this.starAnimationTL.kill();
    EHDI.GAME.soundManager.playSFX("button_sfx", 0.7);
    EHDI.GAME.sceneManager.popPopUp();
    EHDI.GAME.sceneManager.changeScene(new EHDI.scene.TitleScene(), {alpha : new EHDI.scene.TransitionParameter(0,1), duration : 0.25});
};